import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=37e3605a&scoped=true"
import script from "./InputCurrency.vue?vue&type=script&lang=js"
export * from "./InputCurrency.vue?vue&type=script&lang=js"
import style0 from "./InputCurrency.vue?vue&type=style&index=0&id=37e3605a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e3605a",
  null
  
)

export default component.exports